import PropTypes from "prop-types";
export var colorPropType = function colorPropType(props, propName, componentName) {
  if (props[propName] && !/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(props[propName])) {
    return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ", expected a color in hex of length 6 or 3 like #789 or #123456"));
  }
};
export var ThemePropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  white: colorPropType,
  black: colorPropType,
  lightBackground: colorPropType,
  contrast: colorPropType,
  border: colorPropType,
  disabled: colorPropType,
  light: colorPropType,
  icon: colorPropType,
  primary: colorPropType,
  primaryLight: colorPropType,
  primaryDark: colorPropType,
  secondary: colorPropType,
  secondaryLight: colorPropType,
  secondaryHover: colorPropType,
  secondaryDark: colorPropType,
  highlight: colorPropType,
  highlightLight: colorPropType,
  alert: colorPropType,
  ether: colorPropType,
  negative: colorPropType
});
export var orpTheme = {
  name: "Orion Theme",
  white: "#fff",
  black: "#000",
  lightBackground: "#f9f9fa",
  contrast: "#ecf0f1",
  border: "#d9dfe2",
  disabled: "#959595",
  light: "#95989a",
  icon: "#9a9a9a",
  primary: "#353535",
  primaryLight: "#aeaeae",
  primaryDark: "#2f2f2f",
  secondary: "#e8551f",
  secondaryLight: "#f19b81",
  secondaryHover: "#f7dfd6",
  secondaryDark: "#ca4515",
  secondaryDisabled: "#f7dfd6",
  secondaryVariant: "#f19b81",
  highlight: "#058ed9",
  highlightLight: "#6cb5e2",
  alert: "#d9534f",
  ether: "#545454",
  negative: "#ff0000"
};
export var mlpTheme = {
  name: "Millenium Theme",
  white: "#fff",
  black: "#000",
  lightBackground: "#f9f9fa",
  contrast: "#ecf0f1",
  border: "#d9dfe2",
  disabled: "#959595",
  light: "#95989a",
  primary: "#0a1832",
  secondary: "#00aeac",
  secondaryLight: "#00aeac",
  secondaryHover: "#71afae",
  secondaryDark: "#008584",
  secondaryDisabled: "#ccefee",
  secondaryVariant: "#a3cccc",
  highlight: "#ccefee",
  alert: "#d9534f",
  ether: "#545454",
  negative: "#ff0000"
};
export var mlpEqumanTheme = {
  name: "Millenium Equman Theme",
  white: "#fff",
  black: "#000",
  lightBackground: "#f9f9fa",
  contrast: "#ecf0f1",
  border: "#d9dfe2",
  disabled: "#959595",
  light: "#95989a",
  primary: "#0a1832",
  secondary: "#4688F0",
  secondaryLight: "#A9C8F8",
  secondaryHover: "#A9C8F8",
  secondaryDark: "#A9C8F8",
  secondaryDisabled: "#ecf0f1",
  secondaryVariant: "#A9C8F8",
  highlight: "#A9C8F8",
  alert: "#d9534f",
  ether: "#545454",
  negative: "#ff0000",
  sucess: "#0AAFAD",
  warning: "#EBC24A"
};